import angular from 'angular';
import {
    IMovimentacaoPeriodoForm,
    IMovimentacaoPeriodoMonthOption,
    IMovimentacaoPeriodoStatusOption
} from '../../models/movimentacoes-periodos-ui.model';
import {
    MOVIMENTACAO_PERIOD_MONTH_OPTIONS,
    MOVIMENTACAO_PERIOD_STATUS_OPTIONS
} from '../../constants/movimentacoes-periodos-ui.constants';
import {
    PeriodoFormCancelCallback,
    PeriodoFormSubmitCallback
} from './movimentacoes-periodo-form.model';

export class MovimentacoesPeriodoFormController implements angular.IController {
    public model: IMovimentacaoPeriodoForm;
    public busy = false;
    public submitLabel?: string;
    public busyLabel?: string;
    public cancelLabel?: string;
    public showCancel?: boolean;
    public showSituacao?: boolean;
    public disableCompetencia?: boolean;
    public readOnly?: boolean;
    public months?: IMovimentacaoPeriodoMonthOption[];
    public years?: number[];
    public statusOptions?: IMovimentacaoPeriodoStatusOption[];
    public onSubmit: PeriodoFormSubmitCallback;
    public onCancel?: PeriodoFormCancelCallback;

    public resolvedMonths: IMovimentacaoPeriodoMonthOption[] = MOVIMENTACAO_PERIOD_MONTH_OPTIONS;
    public resolvedYears: number[] = [];
    public resolvedStatusOptions: IMovimentacaoPeriodoStatusOption[] = MOVIMENTACAO_PERIOD_STATUS_OPTIONS;

    public $onInit(): void {
        this.resolvedMonths = this.months && this.months.length
            ? this.months
            : MOVIMENTACAO_PERIOD_MONTH_OPTIONS;
        this.resolvedYears = this.resolveYears();
        this.resolvedStatusOptions = this.statusOptions && this.statusOptions.length
            ? this.statusOptions
            : MOVIMENTACAO_PERIOD_STATUS_OPTIONS;
    }

    public $onChanges(changesObj: angular.IOnChangesObject): void {
        if (changesObj.years || changesObj.model || changesObj.months) {
            this.resolvedMonths = this.months && this.months.length
                ? this.months
                : MOVIMENTACAO_PERIOD_MONTH_OPTIONS;
            this.resolvedYears = this.resolveYears();
        }
    }

    public getSubmitLabel(): string {
        return this.submitLabel || 'Criar e abrir';
    }

    public getCancelLabel(): string {
        return this.cancelLabel || 'Cancelar';
    }

    public getBusyLabel(): string {
        return this.busyLabel || 'Criando...';
    }

    public shouldShowCancel(): boolean {
        return this.showCancel !== false;
    }

    public shouldShowSituacao(): boolean {
        return this.showSituacao === true;
    }

    public submit(form?: angular.IFormController): void {
        if (this.busy || this.readOnly || !this.onSubmit) {
            return;
        }

        if (form && form.$invalid) {
            return;
        }

        this.onSubmit({ payload: angular.copy(this.model) });
    }

    public cancel(): void {
        if (this.onCancel) {
            this.onCancel();
        }
    }

    private resolveYears(): number[] {
        if (Array.isArray(this.years) && this.years.length) {
            return this.years.slice();
        }

        const referenceYear = this.resolveReferenceYear();
        const start = Math.max(2000, referenceYear - 11);
        const end = referenceYear + 1;
        const resolved: number[] = [];

        for (let year = end; year >= start; year -= 1) {
            resolved.push(year);
        }

        return resolved;
    }

    private resolveReferenceYear(): number {
        const modelYear = Number(this.model && this.model.ano);
        const currentYear = new Date().getFullYear();

        if (Number.isFinite(modelYear) && modelYear >= 2000) {
            return modelYear;
        }

        return currentYear;
    }
}
